export default "__VITE_ASSET__K8853_15__"